import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PropTypes from "prop-types";
// material ui core
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import { CardActions, Collapse } from "@material-ui/core";

// Style
import { withStyles } from "@material-ui/core/styles";
import { countries } from "../Subscription/countries";
import { states } from "../Subscription/states";
import subscriptionCommon from "../Subscription/common";

// Library
import _ from "lodash";

class BillingInfo extends React.Component {
  BillingInfoRender = () => {
    const { classes, orderState, handleChange, handleChangeCountry, handleChangeState, toggleConnectors } = this.props;
    return (
      <React.Fragment>
        <Paper className={classes.row} elevation={0}>
          <CardActions className={classes.listHeader} onClick={toggleConnectors("Billing")}>
            {/* <IconButton aria-expanded={true} aria-label="Show more">
                            {!orderState.collapsed["Billing"] ? <Remove /> : <Add />}
                        </IconButton> */}
            <Typography variant="h5" gutterBottom>
              Billing Information
            </Typography>
          </CardActions>
          <Collapse in={!orderState.collapsed["Billing"]} timeout="auto" unmountOnExit>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <TextField
                  id="billing_address_line_1"
                  className={classes.textfield}
                  variant="outlined"
                  label="Address"
                  onChange={handleChange}
                  value={orderState.billing_address_line_1}
                  inputProps={{ maxLength: 150 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="billing_city"
                  className={classes.textfield}
                  variant="outlined"
                  label="City"
                  onChange={handleChange}
                  value={orderState.billing_city}
                  inputProps={{ maxLength: 100 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="billing_zip"
                  // error ={ !orderState.enableValidators || !states[orderState.billing_country] || orderState.billing_zip && (orderState.billing_zip.trim().length !== 0) ? false : true }
                  className={classes.textfield}
                  variant="outlined"
                  label="Zip/Postal Code"
                  onChange={handleChange}
                  value={orderState.billing_zip}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl className={classes.formControl}>
                  <InputLabel>Country</InputLabel>
                  <Select
                    native
                    value={orderState.billing_country}
                    onChange={handleChangeCountry}
                    inputProps={{
                      name: "Country",
                      id: "billing_country"
                    }}
                  >
                    {_.map(countries, x => {
                      return (
                        <option value={x.alpha2Code} key={x.alpha2Code}>
                          {x.name}
                        </option>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                {(() => {
                  if (states[orderState.billing_country]) {
                    const selects = [<option value="" key="state_empty" />];
                    _.map(states[orderState.billing_country], (val, key) => {
                      selects.push(
                        <option value={key} key={key}>
                          {val}
                        </option>
                      );
                    });
                    return (
                      <FormControl
                        className={classes.formControl}
                        // error ={ !orderState.enableValidators || orderState.billing_state_code && (orderState.billing_state_code.trim().length !== 0) ? false : true }
                      >
                        <InputLabel>State *</InputLabel>
                        <Select
                          native
                          value={orderState.billing_state_code}
                          onChange={handleChangeState}
                          inputProps={{
                            name: "State",
                            id: "billing_state_code"
                          }}
                        >
                          {selects}
                        </Select>
                      </FormControl>
                    );
                  } else
                    return (
                      <TextField
                        id="billing_state"
                        className={classes.textfield}
                        variant="outlined"
                        label="State"
                        onChange={handleChange}
                        value={orderState.billing_state}
                        inputProps={{ maxLength: 100 }}
                      />
                    );
                })()}
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </React.Fragment>
    );
  };

  render() {
    return this.BillingInfoRender();
  }
}

BillingInfo.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

BillingInfo = connect(
  mapStateToProps,
  mapDispatchToProps
)(BillingInfo);

export default withStyles(subscriptionCommon.styles)(BillingInfo);
